//all cost modelling route constants

export const shouldCostLibraryApiRoutes = {
  getShouldCostFilters: '/v1/landing/get-filter-data',
  getShouldCostModelsByFilters: '/v1/cost-modelling/get-models-by-filters',
  getShouldCostKPIs: '/shouldCostSummary/kpi',
  getShouldCostModelDetails:'/v1/cost-modelling/get-should-cost-model-details',
  getModelMetaData: '/v1/should-cost-analysis/get-model-meta-data',
  deleteShouldCostModel: '/v1/cost-modelling/should-cost-library/delete',
  getCommodityData: '/v1/should-cost-analysis/get-commodity',
  getCommodityKPIs: '/v1/should-cost-analysis/commodity-kpi',
  getCostComponentList: '/v1/should-cost-analysis/get-standard-cost-components-list',
  saveCreatedModel:'/v1/cost-modelling/save-breakdown',
  saveAsDraftModel:'/v1/cost-modelling/draft-model',
  previewDownloadShouldCost:'/v1/cost-modelling/preview-download',
  getShouldCostBreakdownForModel:'/v1/cost-modelling/get-should-cost-breakdown',
  editCreatedModel:'/v1/cost-modelling/edit-model',
  getMiniIfaDataPreview: '/v1/cost-modelling/get-mini-ifa-preview-data',
  getBomAndChartDataPreview: '/v1/cost-modelling/get-chart-bom-preview-data',
  getMiniIfa: '/v1/cost-modelling/get-mini-ifa',
  getBomAndChart: '/v1/cost-modelling/get-chart-bom',
  getTotalModelCount: '/v1/cost-modelling/get-total-model-count',
  getDpcdData: '/v1/cost-modelling/get-dpcd-data'

}

export const skuShouldCostWorkbenchApiRoutes = {
  getSkuKpis:'/v1/cost-modelling/get-kpi',
  getSkuList: '/v1/cost-modelling/get-sku-list',
  getTotalSkuCount:'/v1/cost-modelling/get-total-sku-count',
  attachModelsToSku: '/v1/cost-modelling/attach-sku-model',
  setFinalModel: '/v1/should-cost-analysis/set-final-model',
  getShouldCostBreakdownForModel: '/v1/should-cost-analysis/get-should-cost-breakdown',
  getShouldCostModelsBySku: '/v1/should-cost-analysis/get-shouldcost-models-by-sku',
  checkIfaProgress: '/v2/should-cost-analysis/is-calulating',
  downloadShouldCost:'/v1/cost-modelling/download-should-cost',
  getAllVendorsForSku: '/v1/should-cost-analysis/get-all-vendors-for-sku',
  attachFilesToModel: '/v1/should-cost-analysis/get-should-cost-attachments',
  getShouldCostModelDetails: '/v1/should-cost-analysis/get-should-cost-model-details',
  getCurrencyExchangeRate: '/v1/should-cost-analysis/get-currency-exchange-rate',
  getMaxDate: 'v1/should-cost-analysis/get-commodity-max-date',
  deleteSkuShouldCostMapping:'/v1/cost-modelling/delete-sku-model-mapping',

  downloadFile: 'v1/should-cost-analysis/download-template',
  validateFile: '/v1/should-cost-analysis/validate-files',
  uploadFile: '/v1/should-cost-analysis/upload-files',
  getVendorPoData: 'v1/cost-modelling/get-vendor-po-data',
  getPoTrendData: 'v1/cost-modelling/get-po-trend-data',
}
